<div *ngIf="IsLoading" class="loader_cls">
  <div class="app-loader"></div>
</div>

<div class="policyquotescls reportclaimcls">
  <div *ngIf="!isFromManagePolicy" class="row">
    <div class="col-md-6">
      <h4 class="heading_search_policies">Report a Claim</h4>
    </div>
    <div class="col-md-6">
      <button style="float:right;margin-left: 15px;" name="DocumentBtn" id="DocumentBtnID"
        class="btn btn-small btn_create_policy_quotes mt-1" (click)="clickDocument()">
        <i name="DocumentBtnIcon" id="DocumentBtnIconID" class="fa fa-file"></i> &nbsp;
        Document Center
      </button>
      <button style="float:right" name="OnlineQuoteBtn" id="OnlineQuoteBtnID"
        class="btn btn-small btn_create_policy_quotes mt-1" (click)="CreateOnlineQuote()">
        <i name="OnlineQuoteIcon" id="OnlineQuoteIconID" class="fa fa-plus-circle"></i> &nbsp;
        Create New Online Quote
      </button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-lg-12 col-md-12">
      <label name="searchPolicies" id="searchPoliciesID" class="label_cls">Search Policies</label>
      <div class="input-group search_policies" *ngIf="!IsBFMInternal">
        <span class="p-input-icon-right">
          <i class="pi pi-search"></i>
          <input autocomplete="off" type="text" class="globalfilter_bar global_search_wid" pInputText
            name="searchPoliciesFilter" id="searchPoliciesFilterID" placeholder="Policy number or Insured's Name"
            [(ngModel)]="PolicyorName" (input)="filterPolicy()" />
        </span>
      </div>
      <div class="input-group internalSearch" *ngIf="IsBFMInternal">
        <span class="p-input-icon-right" style="display: flex;">
            <input autocomplete="off" type="text" class="globalfilter_bar global_search_wid" pInputText name="searchPoliciesFilter"
                id="searchPoliciesFilterID" placeholder="Policy number or Insured's Name"
                [(ngModel)]="PolicyorName" />
            <button name="DocumentBtn" id="DocumentBtnID"
                class="btn-small btn_create_policy_quotes btn_search" (click)="searchForPolicy()">
                <i name="DocumentBtnIcon" id="DocumentBtnIconID" class="fa fa-search"></i> &nbsp;
                Search
            </button>
        </span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 mt-2">
      <div id="accordion" class="accordion" *ngIf="filteredList.length>0" style="width: 100%;">
        <div class="card mb-0" [id]="'card' + i" *ngFor="let policy of filteredList; let i=index;">
          <a class="card-header">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-2 col-md-2 col-12 policy_Accordian">
                  {{policy?.nameInsured}}
                </div>
                <div class="col-lg-4 col-md-4 col-12 policy_Accordian">
                  {{policy?.jobSiteAddress}}
                </div>
                <div class="col-lg-3 col-md-3 col-12 policy_Accordian">
                  <span class="label_cls">Pol Eff: </span>{{policy?.effectiveDate |
                  date:'MM/dd/yyyy'}} - {{policy?.expireDate | date:'MM/dd/yyyy'}}
                </div>
                <div class="col-lg-3">
                  <button title="Report a Claim" style="float:right" (click)="openReportClaim(policy,i)"
                    name="OnlineQuoteBtn" id="OnlineQuoteBtnID" class="btn btn-small btn_create_policy_quotes ml-2">
                    Report a Claim
                  </button>
                </div>
              </div>
            </div>

            <div style="padding: 5px 12px;">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-2 col-md-3 col-12 policy_num pr-0 policy_Accordian">
                      <span *ngIf="policy?.nameInsured">{{policy?.productName}}</span>
                      <!-- <span *ngIf="policy?.policyNumber">{{policy?.policyNumber}}</span> -->
                    </div>

                    <div class="col-lg-4">
                      <label><span name="billplan" id="billplanID" class="label_cls">Policy#
                          :
                        </span> {{policy?.policyNumber}}</label>
                    </div>
                    <div class="col-lg-3">
                      <label><span name="totalpremium" id="totalpremiumID" class="label_cls">Total Premium: </span> $
                        {{policy?.summaryTotals?.brPremiumAmount}}</label>
                    </div>
                    <div class="col-lg-3 text-center">
                      <label class="row" style="justify-content: center;">
                        <span name="status" id="statusID" class="label_cls">Status: {{policy?.status}}</span>
                        <div style="margin-left: 5px;" *ngIf="(['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION'].includes(policy?.status.toUpperCase()))"> as of {{policy?.modifyDate | date:"MM/dd/yyyy"}}</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <p-paginator name="paginator" id="paginatorID" class="gen-paginator-override mousePointer"
    *ngIf="!isFromManagePolicy && filteredList.length>0" [rows]="10" [totalRecords]="PolicyQuotesList.length"
    (onPageChange)="paginate($event)"></p-paginator>
  <p-dialog header="" class="dialog_box_new" [(visible)]="isShowReportClaim" (onHide)="closeReportClaim()"
    [modal]="true" [baseZIndex]="1000" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      <div class="row" style="width:98%">
        <div class="col-lg-5 col-md-5 col-12">
          <!-- <span class="policyHeaderLbl">{{policyChangeModal?.nameInsured}}</span> -->
          <span class="policyHeaderLbl">{{policyDetails?.clientInfo?.insuredName}}</span>
        </div>
        <div class="col-lg-4 col-md-4 col-12">
          <!-- <span class="policyHeaderLbl mr-2" *ngIf="policyChangeModal?.nameInsured">{{policyChangeModal?.productName}}</span> -->
          <span class="policyHeaderLbl mr-2">{{currentPolicy?.productName}}</span>
        </div>
        <div class="col-lg-3 col-md-3 col-12" style="text-align: right;">
          <!-- <span class="policyHeaderLbl" *ngIf="policyChangeModal?.policyNumber">{{policyChangeModal?.policyNumber}}</span> -->
          <span class="policyHeaderLbl">{{policyDetails.policyNumber}}</span>
          <!-- Policy Eff: {{policyDetails?.policyStartDate |
            date:'MM/dd/yyyy'}} - {{policyDetails?.policyEndDate | date:'MM/dd/yyyy'}} -->
        </div>
      </div>
    </ng-template>
    <div style="margin-top: 15px;">
      <div class="cardheading">
        <span style="margin-left: 5px;">Policy Details</span>
        <span style="float: right; margin-right: 5px;">
          Status: {{ policyDetails?.status }} <span *ngIf="(['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION'].includes(policyDetails?.status?.toUpperCase()))"> as of {{policyDetails?.modifyDate | date:"MM/dd/yyyy"}}</span>
        </span>
      </div>
      <div class="policyCardHeader">
        <div class="row" style="font-size: 13px;margin-top: 0.9rem!important;">
          <div class="col-lg-6">
            <div style="width:100%;float:left">
              <span class="policyHeading">Policy Eff: </span>
              <span class="policyLbl"> {{policyDetails?.policyStartDate |
                date:'MM/dd/yyyy'}} {{policyDetails?.policyEndDate?'-':''}}
                <span>{{policyDetails?.policyEndDate
                  | date:'MM/dd/yyyy'}}</span></span>
            </div>
          </div>
          <div class="col-lg-6">
            <div style="width:50%;float:right">
              <span class="policyHeading">Total Premium: </span>
              <span class="policyLbl">{{policyDetails?.premium}}</span>
            </div>
          </div>
        </div>
        <div class="row" style="font-size: 13px;margin-top: 0.9rem!important;">
          <div class="col-lg-12">
            <div style="width:100%;float:left">
              <span class="policyHeading">Project Address: </span>
              <span class="policyLbl">{{policyDetails?.clientInfo?.jobsiteAddress[0]?.addressNo}} {{policyDetails?.clientInfo?.jobsiteAddress[0]?.addressLine1}}
                {{policyDetails?.clientInfo?.jobsiteAddress[0]?.city}}
                {{policyDetails?.clientInfo?.jobsiteAddress[0]?.state}}
                {{policyDetails?.clientInfo?.jobsiteAddress[0]?.zip}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px;">
      <h4 style="font-weight: bold;color: black;">Report a Claim</h4>
      <form #reportForm="ngForm" (ngSubmit)="submitReportClaim();">
        <div class="insuredCon">
          <span style="text-decoration: underline;color: black !important;font-weight: 600;">Insured Contact
            Information</span>
          <div class="row mt-2 mb-3">
            <div class="col-lg-4 col-4">
              <span class="policyHeading">First Name:<span style="color:red;margin-left: 2px;">*</span></span><br>
              <input type="text" class="form-control address_controls" id="FirstName" name="FirstName"
                #FirstName="ngModel" [(ngModel)]="dao.reportClaimData.FirstName" placeholder="First Name" />
            </div>
            <div class="col-lg-4 col-4">
              <span class="policyHeading">Last Name:<span style="color:red;margin-left: 2px;">*</span></span><br>
              <input type="text" class="form-control address_controls" id="LastName" name="LastName" #LastName="ngModel"
                [(ngModel)]="dao.reportClaimData.LastName" placeholder="Last Name" />
            </div>
            <div class="col-lg-4 col-4 inputMask">
              <span class="policyHeading">Phone:<span style="color:red;margin-left: 2px;">*</span></span><br>
              <p-inputMask class="form-control reportClaimMask" id="Phone" name="Phone" #Phone="ngModel"
                [(ngModel)]="dao.reportClaimData.Phone" mask="999-999-9999" placeholder="Phone"></p-inputMask>
            </div>
            <div class="col-lg-4 col-4 inputMask mt-2">
              <span class="policyHeading">Alternate Phone:</span><br>
              <p-inputMask class="form-control reportClaimMask" id="AlternatePhone" name="AlternatePhone" #AlternatePhone="ngModel"
                [(ngModel)]="dao.reportClaimData.AlternatePhone" mask="999-999-9999"
                placeholder="Alternate Phone"></p-inputMask>
            </div>
            <div class="col-lg-4 col-4 mt-2">
              <span class="policyHeading">Email:</span><br>
              <input type="text" class="form-control address_controls" id="Email" name="Email"
              [(ngModel)]="dao.reportClaimData.Email" placeholder="Email" pTooltip="Enter an email to receive confirmation details" />
            </div>
          </div>
        </div>
        <div style="padding: 2px 10px;">
          <div class="row mt-2 mb-2" style="padding: 0px 15px;">
            <div class="col-lg-4 col-4">
              <div class="row">
                <span class="policyHeading" style="margin-right: 25px;margin-top: 5px;">Date of Loss:<span
                    style="color:red;margin-left: 2px;">*</span></span>
                <!-- </div>
              <div class="col-lg-3 col-3"> -->
                <div style="padding: 0px 10px 0px 0px;width: 100%;">
                  <p-calendar name="dateOfLoss" class="dateOfLoss" monthNavigator="true" yearNavigator="true"
                    #dateOfLoss="ngModel" id="dateOfLoss" [yearRange]="minYear+':'+maxYear" appendTo="body"
                    [(ngModel)]="dao.reportClaimData.DateOfLoss" [minDate]="minLossDate"  [maxDate]="maxLossDate"
                    placeholder="Date of Loss" [showIcon]="true" selectOtherMonths="true">
                  </p-calendar>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-4" style="text-align: right;">
              <div class="row">
                <span class="policyHeading" style="margin-right: 10px;margin-top: 5px;">Cause of Loss:<span
                    style="color:red;margin-left: 2px;">*</span></span>
                <!-- </div>
            <div class="col-lg-3 col-3"> -->
                <div style="padding: 0px 10px 0px 0px;width: 100%;text-align: left;">
                  <p-dropdown [options]="typeOfLossList" optionLabel="text" optionValue="code" name="TempTypeOfLoss"
                    class="stateDropdown padding_10 reportclaimdrop" placeholder="Select Cause of Loss"
                    #TempTypeOfLoss="ngModel" id="TempTypeOfLoss" (onChange)="changeLossType()" 
                    [(ngModel)]="dao.reportClaimData.TempTypeOfLoss" inputId="TempTypeOfLoss">
                  </p-dropdown>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-4" *ngIf="isShowSubType">
              <div class="row">
                <span class="policyHeading" style="margin-right: 5px;margin-top: 5px;">Additional Options:<span
                  style="color:red;margin-left: 2px;">*</span></span>
                <!-- </div>
            <div class="col-lg-3 col-3" *ngIf="isShowSubType"> -->
                <div style="padding: 0px 10px 0px 0px;width: 100%;text-align: left;">
                  <p-dropdown [options]="subTypeOfLossList" optionLabel="text" optionValue="code" name="SubTypeofLoss"
                    class="stateDropdown padding_10 reportclaimdrop" placeholder="Select Addditional Options"
                    #SubTypeofLoss="ngModel" id="SubTypeofLoss" [(ngModel)]="dao.reportClaimData.SubTypeOfLoss"
                    inputId="SubTypeofLoss">
                  </p-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="row col-lg-12 col-12 mb-2 mt-3">
            <span style="margin-top: 5px;"
              class="policyHeading {{reportForm.submitted && (dao.reportClaimData.isLossProjectAddress == undefined || dao.reportClaimData.isLossProjectAddress == '') ? 'text-red' : '' }}">Did
              the loss occur at the Project Address?<span style="color:red;margin-left: 2px;">*</span></span>
            <div class="d-flex" style="margin-left: 20px;">
              <div class="p-field-radiobutton">
                <p-radioButton name="Yes" value="Yes" inputId="Yes" (onClick)="ChangeLossOccur()"
                  [(ngModel)]="dao.reportClaimData.isLossProjectAddress"></p-radioButton>
                <label class="p_radiobtn_labelcls" for="Yes"><b>Yes</b></label>
                <p-radioButton name="No" value="No" inputId="No" (onClick)="ChangeLossOccur()"
                  [(ngModel)]="dao.reportClaimData.isLossProjectAddress"></p-radioButton>
                <label class="p_radiobtn_labelcls" for="No"><b>No</b></label>
              </div>
            </div>
          </div>
          <div class="mb-2 mt-2 row" *ngIf="dao.reportClaimData.isLossProjectAddress == 'No'">
            <div class="col-lg-12 col-12">
              <span class="policyHeading">Location of Loss:<span style="color:red;margin-left: 2px;">*</span></span><br>
              <div class="row mb-4">
                <div class="col-lg-3 col-3" style="padding-right: 0;">
                  <input type="text" class="form-control " name="projectaddress1" placeholder="Address"
                    [(ngModel)]="dao.reportClaimData.Address" #projectaddress1="ngModel" 
                    [ngModelOptions]="{standalone: true}" maxlength="40" />
                </div>
                <div class="col-lg-3 col-3" style="padding-right: 0;">
                  <input type="text" class="form-control " name="projectcity"
                    [(ngModel)]="dao.reportClaimData.City" #projectcity="ngModel" [ngModelOptions]="{standalone: true}" placeholder="City" />
                </div>
                <div class="col-lg-3 col-3" style="padding-right: 0;">
                  <input type="text" class="form-control " name="projectstate"
                    [(ngModel)]="dao.reportClaimData.State" #projectstate="ngModel"
                    [ngModelOptions]="{standalone: true}" placeholder="State" />
                </div>
                <div class="col-lg-3 col-3">
                  <p-inputNumber class="zipCode_popup" placeholder="Zip Code" [(ngModel)]="dao.reportClaimData.Zip"
                    #projectzip="ngModel" [ngModelOptions]="{standalone: true}" name="Zip1" [maxlength]="5" 
                    [useGrouping]="false">
                  </p-inputNumber>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2 mt-3">
            <div class="col-lg-3 col-3">
              <span class="policyHeading">Description of Loss:<span style="color:red;margin-left: 2px;">*</span></span>
            </div>
            <div class="col-lg-9 col-9">
              <div class="row">
                <div class="col-lg-12 d-flex">
                  <textarea [(ngModel)]="dao.reportClaimData.DescriptionOfLoss" autoResize="autoResize" pInputTextarea
                    class="reportTextArea" name="DescriptionOfLoss" id="DescriptionOfLoss"
                    title="{{dao.reportClaimData.DescriptionOfLoss}}" #DescriptionOfLoss="ngModel"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2 mt-3">
            <div class="col-lg-6">
              <span class="policyHeading">Attach Loss documentation related this claim:</span>
              <a name="reportfileUpload" id="reportfileUploadfileUploadID" class="drag_and_drop">
                <h3 class="mb-0"> Drag &amp; Drop Files Here </h3>
                <p class="mb-0">or</p>
                <h6> Browse Files </h6>
              </a>
              <p-fileUpload name="demo[]" id="demoID[]" class="UploadCls" (onSelect)="onUpload($event)"
                (click)="clickUpload($event)" accept=".csv, .xls, .docx, .doc, .pdf, .jpg" multiple="multiple"
                maxFileSize="15728640" invalidFileTypeMessageSummary="{0}: Invalid file type.">
              </p-fileUpload>
            </div>
            <div class="col-lg-6">
              <div class="row show-file-in-browser" *ngFor="let item of uploadFiles; let i= index;">
                <div class="col-lg-12 mt-3">
                  <div class="upload_file_icon mr-2">
                    <i class="fa fa-file-o" aria-hidden="true"></i>
                  </div>
                  <div class="upload_file_details">
                    <div class="upload_file_name" title="{{item?.fileName}}">
                      {{item?.fileName}}
                    </div>
                    <span class="row text-right float-right upload_size_details"><b
                        class="color_dark">({{item?.filesize}})</b>
                      <i class="fa fa-times-circle-o ml-2 fa-lg color_green pointerCur"
                        title="Delete {{item?.fileName}}" (click)="deleteFile(item,i)" aria-hidden="true"></i>
                    </span><br>
                    <p-progressBar [value]="item?.progressValue"></p-progressBar>
                  </div>
                </div>
              </div>              
            </div>
          </div>
          <div class="row float-right">
            <div class="col-lg-12 mb-2">
              <button class="policyCloseBtn" [disabled]="isSubmitBtnDisabled()" title="Submit Claim"
                style="padding: 0px 20px;" type="submit">Submit
                Claim</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </p-dialog>
  <p-dialog [(visible)]="showReportClaimConfirmation" (onHide)="closeReportClaim()" [baseZIndex]="1000"
    [draggable]="false" [resizable]="false" [closable]="true" [modal]="true" styleClass="EditMailingPopUp MailingPopUp">
    <ng-template pTemplate="header">
      <div style="width: 100%;">
        <span>Claim Confirmation {{ErrorMessage != '' ? '- Error' : ''}}</span>
        <span style="float: right;text-align: right;">{{policyDetails?.clientInfo?.insuredName}}</span>
      </div>
    </ng-template>
    <div class="row mt-2">
      <div class="col-lg-12">
        <span *ngIf="ClaimNumber != ''" class="confirmTxt">Submission was successful, Claim Number <span style="color: red; font-weight: 500;">{{ClaimNumber}}</span>
          has been created. A claims representative will be in touch with <span style="color:#002b49 !important;font-weight: 500;">{{dao.reportClaimData.FirstName}} {{dao.reportClaimData.LastName}}</span> within 2 business days. Should you need immediate assistance please contact us at <span
            style="color: #007bff;">844-462-3600</span>, option <span style="color: #007bff;">6</span>, or via email: <a style="text-decoration: underline !important;" href="mailto:claims@berkleymarine.com">claims&#64;berkleymarine.com</a>. You can also visit the <a style="color:#002b49 !important;font-weight: 500;" href="https://agentportal.berkleymarine.com/">Document Center</a> for updates throughout the claim process.</span>
        <span *ngIf="ClaimNumber == ''">
          Information regarding your claim has been captured and forwarded to our Claims Department. A team member will be in touch with you as soon as possible.  You may also contact us directly at 844-462-3600, Option 6 or <a href='mailto:claims@berkleymarine.com'>claims&#64;berkleymarine.com</a> with any questions or concerns. 
        </span>
      </div>
    </div>
    <div class="row float-right mt-3">
      <button class="policyCloseBtn" (click)="closeReportClaim();">Close</button>
    </div>
  </p-dialog>
  <!-- <p-confirmDialog [style]="{width: '50vw'}" styleClass="confirmbtn" [baseZIndex]="1000"
    rejectButtonStyleClass="p-button-text"></p-confirmDialog> -->
</div>
